import React from 'react';
import { Picture, Modal } from 'components/UI';
import { Link } from 'react-router-dom';
import {
  gfxApac,
  gfxEvents,
  gfxMixers,
  gfxPerks,
  imgTableBenefits,
} from 'assets';

const Benefits = () => {
  const benefitLayout = (imgSrc, title) => (
    <Link to="/faq" className="flex flex-col items-center justify-center">
      <Picture src={imgSrc} className="h-24" />
      <span className="text-md text-center mt-12">{title}</span>
    </Link>
  );

  return (
    <div className="flex flex-col items-center mt-12 mb-20 md:mb-24 mx-auto px-6">
      <Modal content={<Picture src={imgTableBenefits} />}>
        <h2 className="text-center text-easter cursor-pointer">
          Gig Life Pro Membership Benefits
        </h2>
      </Modal>
      <div className="grid grid-cols-2 col-gap-8 row-gap-8 md:grid-cols-4 md:col-gap-24 mt-8 md:mt-20">
        {benefitLayout(gfxApac, 'APAC Insights')}
        {benefitLayout(gfxEvents, 'Member Only Events')}
        {benefitLayout(gfxMixers, 'Connect with professionals')}
        {benefitLayout(gfxPerks, 'Industry Perks')}
      </div>
    </div>
  );
};

export default Benefits;
